import { Component } from '@angular/core';
import { ChartsService } from 'src/app/services/charts.service';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.css'],
})
export class ChartsComponent {
  data = [
    {
      overallscore: 309775,
      Mscrore: 156875,
      score: 152900,
      user: 39,
      name: 'Percient',
      shipId: 'percient_anglerbeta',
      slno: 5,
    },
    {
      overallscore: 212696,
      Mscrore: 147496,
      score: 65200,
      user: 12,
      name: 'ship2',
      shipId: 'ship2_angler_beta',
      slno: 3,
    },
    {
      overallscore: 17718,
      Mscrore: 14618,
      score: 3100,
      user: 2,
      name: 'test_a1_ship',
      shipId: 'test_a1_ship_anglerbeta',
      slno: 9,
    },
    {
      overallscore: 4100,
      Mscrore: 0,
      score: 4100,
      user: 3,
      name: 'test-a',
      shipId: 'test-ship-a_anglerbeta',
      slno: 8,
    },
    {
      overallscore: 4088,
      Mscrore: 1988,
      score: 2100,
      user: 1,
      name: 'shipfleet3',
      shipId: 'shipfleet3_anglerbeta',
      slno: 17,
    },
    {
      overallscore: 2800,
      Mscrore: 0,
      score: 2800,
      user: 6,
      name: 'Flex Amber',
      shipId: 'flex_amber_sh_01',
      slno: 2,
    },
    {
      overallscore: 1600,
      Mscrore: 0,
      score: 1600,
      user: 4,
      name: 'sandeep ship',
      shipId: 'sandeep_anglerbeta',
      slno: 7,
    },
    {
      overallscore: 700,
      Mscrore: 0,
      score: 700,
      user: 1,
      name: 'Flex Artemis',
      shipId: 'flex_artemis_sh_01',
      slno: 1,
    },
    {
      overallscore: 200,
      Mscrore: 0,
      score: 200,
      user: 1,
      name: 'kundan_test',
      shipId: 'kundan_test_anglerbeta',
      slno: 15,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'Flex Rainbow',
      shipId: 'flex_rainbow_sh_01',
      slno: 4,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'MyNewShip2022',
      shipId: 'sept4k_anglerbeta',
      slno: 6,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'Test Ship',
      shipId: 'test_ship_anglerbeta',
      slno: 10,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'MAGELLAN ENDEAVOUR',
      shipId: 'magellan_endeavour_anglerbeta',
      slno: 11,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'TENRYU',
      shipId: 'tenryu_anglerbeta',
      slno: 12,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'LANTANA PLANET',
      shipId: 'lantana_planet_anglerbeta',
      slno: 13,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'ukashatest',
      shipId: 'ukashatest_anglerbeta',
      slno: 14,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'FUJI HORIZON',
      shipId: 'fuji_horizon_anglerbeta',
      slno: 16,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'shipfleet4',
      shipId: 'shipfleet4_anglerbeta',
      slno: 18,
    },
    {
      overallscore: 0,
      Mscrore: 0,
      score: 0,
      user: 0,
      name: 'shipfleet5',
      shipId: 'shipfleet5_anglerbeta',
      slno: 19,
    },
  ];

  chartType: any;
  option1: any;
  option2: any;
  charts: any[] = ['pie', 'line', 'bar', 'column'];
  chartHints = 'Please select a chart type';
  refinedData: any = [];
  axes: string[];
  updateFlag: boolean = false;
  chartName: string;

  constructor(private highchart: ChartsService, private jwt: JwtService, private mixpanel: MixpanelService) {}
  highcharts = this.highchart.highcharts;
  chartOptions = this.highchart.chartOptions;

  filter(data, arr) {
    let prop = Object.keys(data[0]);
    prop.forEach((prop) => {
      arr[prop] = [];
      data.forEach((item) => {
        if (item.hasOwnProperty(prop)) {
          arr[prop].push(item[prop]);
        }
      });
    });
  }

  ngOnInit() {
    this.mixpanel.track("page_view", { page: "Charts", category: "Dashboard", button: "-"  })
    this.jwt.check();
    this.filter(this.data, this.refinedData);
    this.axes = Object.keys(this.refinedData).filter(
      (key) => key !== 'name' && key !== 'shipId'
    );
  }

  hint( inputRef ) {
    if (this.chartType == 'pie') {
      this.chartHints = 'PieChart has only one axis';
      this.option2 = '';
      inputRef.control.markAsUntouched();;
    } else {
      this.chartHints = this.chartType + ' has two axes';
    }
    this.chartCreation();
  }

  save() {
    this.mixpanel.track("button_click", { page: "Charts", category: "Dashboard", button:"Save" })
    let param = {}
    if( this.chartType = 'pie') {
      param = {
        "ChartName": this.chartName,
        "ChartOptions": this.chartOptions,
        "option1": this.option1,
        "type": this.chartType
      }
    } else {
      param = {
        "ChartName": this.chartName,
        "ChartOptions": this.chartOptions,
        "option1": this.option1,
        "option2": this.option2,
        "type": this.chartType
      }
    }
    console.log(param);
  }

  chartCreation() {
    if (this.chartType == 'pie') {
      if (this.option1) {
        let data = this.highchart.json(
          this.refinedData['name'],
          this.refinedData[this.option1]
        );
        this.chartOptions = {
          chart: {
            plotShadow: false,
            type: 'pie',
          },
          title: {
            text: 'Pie',
            align: 'center',
          },
          tooltip: {
            pointFormat:
              '<b>Percentage:</b> {point.percentage:.1f}%<br><b>'+ this.option1.charAt(0).toUpperCase() + this.option1.slice(1)+':</b> {point.y}',
            headerFormat: '<b>{point.key}</b><br>',
          },
          accessibility: {
            point: {
              valueSuffix: '%',
            },
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: false,
              },
              point: {
                events: {
                  legendItemClick: function (event) {
                    if (event.target.visible === false) {
                      return true;
                    }
                    let count = 0;
                    event.target.series.data.forEach((e) => {
                      if (e.visible === true) {
                        count += 1;
                      }
                    });
                    return count > 1;
                  },
                },
              },
              showInLegend: true,
            },
          },
          series: [
            {
              type: 'pie',
              data: data,
            },
          ],
        };
        this.updateFlag = true;
      }
    } else if (this.chartType == 'line' || this.chartType == 'bar' || this.chartType == 'column') {
      if( this.option1 && this.option2 ) {
        this.chartOptions = this.highchart.chartOptions;
        let data = this.highchart.json(
          this.refinedData['name'],
          this.refinedData[this.option2]
        );
        this.chartOptions = {
          chart: {
            plotShadow: false,
            type: this.chartType,
          },
          xAxis: {
            categories: this.refinedData[this.option1],
          },
          yAxis: {
            title: {
              text: '<b>'+this.option2+'</b>',
            },
            min: 0,
          },
          title: {
            text: this.chartType.charAt(0).toUpperCase() + this.chartType.slice(1),
            align: 'center',
          },
          tooltip: {
            headerFormat: '<b>'+ this.option1 +': {point.x}</b><br>',
            pointFormat: '<b>'+ this.option2 +': {point.y}</b>',
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
              },
            },
          },
          series: [
            {
              type: this.chartType,
              name: this.option1,
              data: data,
              events: {
                legendItemClick: function (event) {
                  if (event.target.visible === false) {
                    return true;
                  }
                  let count = 0;
                  event.target.chart.series.forEach((e) => {
                    if (e.visible === true) {
                      count += 1;
                    }
                  });
                  return count > 1;
                },
              }
            },
          ],
        };
      }
      else {
        this.chartOptions.series = [];
      }
      this.updateFlag = true;
    } else {
      this.chartOptions.series = [];
    }
  }


}
